<div class="messages-container" [class.show-chat]="selectedChat" [class.full-height]="selectedChat && isSmallScreen">
  <div class="chat-list">
    <div class="messages-header">
      <h2 class="messages-title">Discussions</h2>
      <button mat-icon-button [matMenuTriggerFor]="menu" class="options-button">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item>
          <mat-icon>settings</mat-icon>
          <span>Paramètres</span>
        </button>
        <button mat-menu-item>
          <mat-icon>help</mat-icon>
          <span>Aide</span>
        </button>
      </mat-menu>
    </div>

    <div class="search-container">
      <mat-form-field appearance="outline" class="search-field">
        <input matInput placeholder="Rechercher de discussion..." [(ngModel)]="searchTerm">
        <button mat-icon-button matSuffix>
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="chat-list-content">
      <div class="chat-item" *ngFor="let chat of filteredChats" (click)="selectChat(chat)" [class.selected]="selectedChat?.id === chat.id">
        <div class="chat-item-content">
          <img [src]="getProfileImage(chat.profileUrl)" alt="Profile" class="profile-image">
          <div class="chat-info">
            <div class="chat-header">
              <div class="name-message-wrapper">
                <span class="chat-name">{{ chat.name }}</span>
                <p class="last-message">
                  <ng-container *ngIf="chat.lastMessage?.imageUrl && !chat.lastMessage?.text">
                    <mat-icon class="multimedia-icon">image</mat-icon>
                    <span>Photo</span>
                  </ng-container>
                  <ng-container *ngIf="chat.lastMessage?.imageUrl && chat.lastMessage?.text">
                    <mat-icon class="multimedia-icon">image</mat-icon>
                    <span>{{ chat.lastMessage.text }}</span>
                  </ng-container>
                  <ng-container *ngIf="chat.lastMessage?.audioUrl">
                    <mat-icon class="multimedia-icon">mic</mat-icon>
                    <span>Message vocal</span>
                  </ng-container>
                  <ng-container *ngIf="!chat.lastMessage?.imageUrl && !chat.lastMessage?.audioUrl">
                    {{ chat.lastMessage?.text || 'Aucun message' }}
                  </ng-container>
                  <ng-container *ngIf="!chat.lastMessage">
                    <span>Aucun message</span>
                  </ng-container>
                </p>
              </div>
              <div class="time-badge-wrapper">
                <span class="chat-time">{{ getFormattedDate(chat.lastMessageTimeStamp) }}</span>
                <div class="unread-badge" *ngIf="chat.unreadCount && chat.unreadCount > 0">
                  {{ chat.unreadCount }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Contenu de la discussion -->
  <div class="chat-content" *ngIf="selectedChat">
    <div class="chat-header">
      <div class="header-content">
        <button class="back-button" (click)="backToChatList()" *ngIf="isSmallScreen">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <img [src]="getProfileImage(selectedChat.profilePicture)" alt="Profile picture" class="profile-image">
        <div class="user-info">
          <span class="user-name">{{ selectedChat.name }}</span>
          <small class="user-status">En ligne</small>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="chatMenu" class="chat-options">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #chatMenu="matMenu">
          <button mat-menu-item>
            <mat-icon>block</mat-icon>
            <span>Bloquer</span>
          </button>
          <button mat-menu-item>
            <mat-icon>report</mat-icon>
            <span>Signaler</span>
          </button>
          <button mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Supprimer la discussion</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="contenu" #messageContainer>
      <ng-container (scroll)="onScroll()" *ngIf="selectedChat">
        <div *ngFor="let message of selectedChat.messages.slice().reverse()" class="message-row">
          <div [ngClass]="{'sent': message.senderId === currentUserId, 'received': message.senderId !== currentUserId}" class="message-content">
            <img *ngIf="message.imageUrl" [src]="message.imageUrl" alt="Comment image" class="comment-image">
            
            <div *ngIf="message.audioUrl && message.audioUrl !== ''" class="audio-message">
              <div class="audio-player-container">
                <img [src]="getProfileImage(message.senderId === currentUserId ? null : selectedChat?.profileUrl)" alt="Profile" class="audio-profile-pic">
                <div class="audio-controls">
                  <button class="play-button" (click)="playAudio(audioPlayer)">
                    <mat-icon>{{ audioPlayer?.paused ? 'play_arrow' : 'pause' }}</mat-icon>
                  </button>
                  <div class="waveform-container">
                    <input type="range" 
                           class="audio-slider" 
                           [value]="getCurrentProgress(audioPlayer)"
                           [max]="getMaxDuration(audioPlayer)"
                           (input)="updateAudioTime($event, audioPlayer)">
                    <audio #audioPlayer [src]="message.audioUrl" preload="metadata" 
                           (loadedmetadata)="onAudioLoaded($event)"
                           (timeupdate)="onTimeUpdate($event)" 
                           class="audio-player">
                      Votre navigateur ne supporte pas l'élément audio.
                    </audio>
                  </div>
                  <div class="audio-duration">{{ getAudioDuration(audioPlayer) }}</div>
                </div>
              </div>
            </div>

            <p *ngIf="message.text" class="mt-0 mb-0 pt-0 pb-0">{{ message.text }}</p>
            <small class="message-time">{{ getMessageFormattedDate(message.timestamp) }}</small>
          </div>
        </div>
      </ng-container>
    </div>

    

    <div class="chat-input">
      <button mat-button color="warn" class="upload-button">
        <label for="photo-upload">
          <input #photoInput (change)="onFileSelected($event)" 
                 id="photo-upload" type="file" accept="image/*"/>
          <mat-icon>insert_photo</mat-icon>
        </label>
      </button>

      <div class="message-input-container">
        <!-- Image preview container -->
        <div class="image-preview-container" *ngIf="selectedImage">
          <img [src]="selectedImage" alt="Preview" class="preview-image">
          <button mat-icon-button class="remove-preview" (click)="removeSelectedImage()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <textarea #messageInput 
                 class="textarea" 
                 placeholder="Écrivez un message..." 
                 (input)="adjustTextareaHeight($event)" 
                 (keydown)="onKeydown($event)"
                 rows="1" 
                 wrap="soft">
        </textarea>
      </div>

      <button mat-icon-button 
              class="send-button"
              [class.active]="messageInput.value.trim() || selectedImage"
              (click)="messageInput.value.trim() || selectedImage ? onSendClick() : null">
        <mat-icon>send</mat-icon>
      </button>

      <div class="recording-indicator" *ngIf="isRecording">
        <span>{{ recordingStatus }}</span>
        <span class="timer">{{ recordingTime }}</span>
      </div>
    </div>

  </div>
</div>